import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  getRosterSetting: {},
  staffStroeData: {},
  roleData: {}
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.SET_STAFF_STROE_DATA](state, data) {
    state.staffStroeData = data
  },
  [types.SET_ROSTER_SETTING](state, data) {
    state.getRosterSetting = data
  },
  [types.SET_ROSTER_ROLE_DATA](state, data) {
    state.roleData = data
  }
}
// getters
const getters = {}

export default {
  state,
  getters,
  actions,
  mutations
}
